import {MathJax, MathJaxContext} from "better-react-mathjax";
import {isNullOrUndefined} from "../../../services/Validator";

export default function CoursesResultsQuestionStatementText({statement, isHovered}) {
    // Used in FlashResultsQuestionItem to display question statement

    // BUILD
    if (isNullOrUndefined(statement))
        return null;
    return (
        <div className={`flex items-start justify-start ${isHovered ? "text-white" : "text-greyLight11"} w-full text-[16px] font-semibold overflow-hidden`}>
            <MathJaxContext>
                <MathJax inline dynamic>
                    <span className={"truncate block max-w-[480px] lg:max-w-[440px]"}>
                        {statement}
                    </span>
                </MathJax>
            </MathJaxContext>
        </div>
    );
}